
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Europa Component Library`}</h1>
    <h2>{`ec.europa.eu`}</h2>
    <p>{`This library contains all available components that you can use to build your own website.`}</p>
    <p>{`All library elements are accompanied by`}</p>
    <ul>
      <li parentName="ul">{`documentation explaining what a component is and how it should be used`}</li>
      <li parentName="ul">{`a visual demonstration`}</li>
      <li parentName="ul">{`HTML/CSS code for implementation`}</li>
    </ul>
    <p>{`For support in building a European Commission website using the ECL, please contact `}<a parentName="p" {...{
        "href": "mailto:Europamanagement@ec.europa.eu"
      }}>{`COMM Europa Management`}</a>{` (CEM).`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;